import React from 'react';
import RefundAction from '../actions/refund-action';
import {RefundComplete, RefundFailed} from './refund-response'
import {SlimBody, BulkyBody} from './refund-request-body';
import TransactionAction from '../actions/transaction-action';
import PurchaseItem from './purchase-item';
import Dispatcher from '../dispatcher';
import Utils from '../utils/utils'
import {VstLoader, VstProgressButton} from 'vstui';
import { Dialog } from "@vitalsource/vstui";
import { createTheme, ThemeProvider } from "@vitalsource/vstui/themes";

export default class RefundRequest extends React.Component {
  constructor(props){
    super(props);
    const { transaction, item } = this.props;
    this.state = {
      refundCodes: transaction.bulk? [] : item.codes.map((c) => c.code)
    };

    this._onRefundSuccess = this._onRefundSuccess.bind(this);
    this._onRefundFailure = this._onRefundFailure.bind(this);
    this._onProgressButtonReset = this._onProgressButtonReset.bind(this);
    this._requestRefund = this._requestRefund.bind(this);
    this._hideModal = this._hideModal.bind(this);
  }

  componentDidMount(){
    Dispatcher.on(Dispatcher.TRANSACTION_REFUND_SUCCESS, this._onRefundSuccess);
    Dispatcher.on(Dispatcher.TRANSACTION_REFUND_FAILURE, this._onRefundFailure);
  }

  componentWillUnmount(){
    Dispatcher.removeListener(Dispatcher.TRANSACTION_REFUND_SUCCESS, this._onRefundSuccess);
    Dispatcher.removeListener(Dispatcher.TRANSACTION_REFUND_FAILURE, this._onRefundFailure);
  }

  _hideModal() {
    TransactionAction.showDetails(this.props.transaction.number);
  }

  _onRefundSuccess(data){
    this.setState({refundSuccess: data.codes === this.state.refundCodes });
  }

  _onRefundFailure(details){
    if(details.itemCodes === this.state.refundCodes){
      this.setState({refundSuccess: false, refundError: true});
    }
  }

  _onProgressButtonReset(){
    let {refundSuccess} = this.state;
    if(refundSuccess === false) {
      this.setState({refundSuccess: undefined});
    } else if (refundSuccess === true) {
      this._hideModal();
    }
  }

  _getReasonDetails(){
    let reasons = [];
    const {dropped, wrong, print, missing, other, otherExplain} = this.state;
    if(other && !otherExplain){ return ''; }

    if(dropped){ reasons.push("Dropped course"); }
    if(wrong){ reasons.push("Wrong book"); }
    if(print){ reasons.push("Purchased print book"); }
    if(missing){ reasons.push("Missing content"); }
    if(other && otherExplain){ reasons.push("Other: " + otherExplain); }

    return reasons.join("; ");
  }

  _requestRefund(){
    const {
            transaction: {bulk, number: transactionId, creditCardType, creditCardNumber, currency},
            item
          } = this.props;
    const {refundCodes: codes} = this.state;
    let details = this._getReasonDetails();
    if(details === '' && (!bulk || codes.length === 0)){
      this.setState({reasonError: true, refundSuccess: false});
    }else{
      this.setState({refundError: false});
      const params = {
        codes,
        isbn: item.sku,
        transactionId,
        reason: this._getReasonDetails(),
        creditCardType,
        creditCardNumber,
        currency: Utils.getCurrencySymbol(currency),
        amount: `${(Utils._itemPrice(item, currency, true) * codes.length).toFixed(2)} ${currency}`,
        bulk
      };
      RefundAction.requestRefund(params);
    }
  }

  _modalTitle() {
    if(this.state.refundError){
      return(
        <div>
          <h2 id="refund-request-title" className="error">{i18n.t('refunds.error')}</h2>
          <p>{i18n.t('refunds.error-explain')}</p>
        </div>
      );
    }else{
      const {transaction: {bulk}} = this.props;
      const text = bulk ? 'refunds.bulk.complete' : 'refunds.sorry';
      return(<h2 id="refund-request-title" className={bulk ? "bulk" : "slim"}>{i18n.t(text)}</h2>);
    }
  }

  render(){
    let body;
    const {transaction, item} = this.props;
    const {refundSuccess, reasonError, refundCodes} = this.state;

    if (transaction) {
      if (refundSuccess === true) {
        body = <RefundComplete
                  transactionNumber={transaction.number}
                  isbn={item.isbn} />
      } else if (refundSuccess === false && refundCodes.length !== 0 && !reasonError) {
        body = <RefundFailed
                  retry={() => this.setState({refundSuccess: undefined, refundError: undefined})}
                  transactionNumber={transaction.number} />
      } else {
        let mainClassName, purchaseItemClassName, refundPolicy, buttonClassName, component, refundText;
        if (transaction.bulk) {
          mainClassName = "";
          purchaseItemClassName = "";
          buttonClassName = "bulk-complete";
          component = <BulkyBody
            setState={(newState) =>this.setState(newState)}
            currency={transaction.currency}
            item={item}
            refundsRequested={refundCodes}
            reasonError={reasonError}
            />;
          refundPolicy = Utils.toHTML(i18n.t('refunds.bulk.policy', {brand: Mulligan.Brand.AccountCenter.brand, policy_url: "https://support.vitalsource.com/hc/en-us/articles/234745668-Bulk-Purchase-Refund-Policy"}));
          refundText = i18n.t("refunds.bulk.complete");
        } else {
          const {dropped, wrong, print, missing, other, otherExplain} = this.state;
          mainClassName = "details-wrapper";
          purchaseItemClassName = "request-refund-header"
          component = <SlimBody
            setState={(newState) =>this.setState(newState)}
            reasons={{dropped, wrong, print, missing, other, otherExplain}}
            reasonError={reasonError}
            />;
          buttonClassName='medium'
          refundPolicy = Utils.toHTML(i18n.t('refunds.policy', {brand: Mulligan.Brand.AccountCenter.brand}));
          refundText = i18n.t("refunds.refund");
        }
        body = (
          <div className="deck refund-request">
            { this._modalTitle() }
            <div className={mainClassName}>
              <PurchaseItem className={purchaseItemClassName}
                item={item}
                transaction={transaction}
                hideRefundButton={true}
                hideDownloadCodes={true}
                isRefund
                hideRight={transaction.bulk} />
              {component}
            </div>
            <p className="policy">
              {refundPolicy}
            </p>

            <div className="button-container">
              <button className="vst-href-text-button" onClick={this._hideModal}>{i18n.t('base.cancel')}</button>
              <VstProgressButton className={buttonClassName}
                progressText="Requesting..."
                success={refundSuccess}
                onReset={this._onProgressButtonReset}
                onClick={this._requestRefund}>{refundText}</VstProgressButton>
            </div>
          </div>
        );
      }
    } else {
      body = <VstLoader />;
    }
    return (
      <Dialog title={''} size="large" onRequestClose={this._hideModal} open>
        {body}
      </Dialog>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/js/components/refund-request.jsx
 **/